import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-action-confirm[type]',
    templateUrl: './action-confirm.component.html',
    styleUrls: ['./action-confirm.component.scss'],
})
export class ActionConfirmComponent {
    @Input() type: 'confirm' | 'done';

    @Input() doneBtnTitle = 'system.done';
    @Input() doneBtnDisable = false;
    @Input() yesBtnTitle = 'system.yes';
    @Input() yesBtnDisable = false;
    @Input() noBtnTitle = 'system.no';
    @Input() noBtnDisable = false;

    @Input() doneDialogCloseValue = true;
    @Input() yesDialogCloseValue = true;
    @Input() noDialogCloseValue = false;

    @Output() doneClick = new EventEmitter<void>();
    @Output() yesClick = new EventEmitter<void>();
    @Output() noClick = new EventEmitter<void>();

    get isConfirmationDialog() {
        return this.type === 'confirm';
    }

    onDoneClick() {
        this.doneClick.emit();
    }

    onYesClick() {
        this.yesClick.emit();
    }

    onNoClick() {
        this.noClick.emit();
    }

}
